import React from 'react'
import { Link } from 'react-router-dom'
import AdditionalHoursAdd from './AdditionHourAdd'
import Constant from '../../Constant'
class AdditionalHoursAddTab extends React.Component {
  state = {
    language_data: [],
  }

  componentDidMount() {
    if (
      this.props.match.params.additional_hour_id !== undefined &&
      this.props.match.params.additional_hour_id !== null &&
      this.props.match.params.additional_hour_id !== 0 &&
      this.props.match.params.additional_hour_id !== ''
    ) {
      this.setState({ additional_hour_id: this.props.match.params.additional_hour_id })
    }
    this.getLanguageList()
  }
  getLanguageList = () => {
    var language_data = Constant.getLanguageList()
    this.setState({
      language_data: language_data,
      language_id: language_data[0].id,
      isLoading: false,
    })
  }
  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-6">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Additional Hour {this.props.match.params.additional_hour_id ? 'Edit' : 'Add'}</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link
                        to={`/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/additionhours-lists`}
                      >
                        Additional Hour List
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">Additional hour add</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <AdditionalHoursAdd
                      goBack={this.props.history.goBack}
                      boatType={this.props.match.params.boatType}
                      boatId={this.props.match.params.boatId}
                      additional_hour_id={this.state.additional_hour_id}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AdditionalHoursAddTab
